/* ============
 * Supplier Index
 * ============
 *
 * This page shows the list of Bills.
 */
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import accountService from './../../../../services/account';
import supplierService from './../../../../services/supplier';
import debounce from 'debounce';
import SearchMixin from './../../../../mixins/search';
import store from './../../../../store';

export default {
  data() {
    return {
      loading: true,
      sortValue: '',
      info:'info',
      primary:'primary',
      limit: 25,
    };
  },

  computed: {
    ...mapGetters({
      suppliers: 'paginateSuppliers',
      view: 'getView',
    }),

    suppliersList() {
      return this.suppliers.items.map((b) => {
       /* let cardClass = '';

        if (b.billStatus === 'Overdue') {
          cardClass = 'card-red';
        } else if (b.billStatus === 'Cleared') {
          cardClass = 'card-green';
        } else if (b.billStatus === 'Sent') {
          cardClass = 'card-yellow';
        }

        Object.assign(b, {
          number: b.billingNumber ? `#${b.billingNumber}` : 'Draft',
          value: `${b.totalValue.toFixed(2)} NOK`,
          amount: `(${b.totalQuantity} ${this.$t('static.bills.index.quantities')})`,
          dueDateFormated: moment(b.dueDate).isValid() ? moment(b.dueDate).format('DD-MM-YYYY') : '-',
          cardClass,
        });*/

        return b;
      });
    },
    suppliersListView() {
      return this.suppliers.items.map(c => ({
        number: c.number,
        code: c.code,
        name: c.name,
        id: c.id
      }));
    },
  },

  watch: {

    view: function(view){
        console.log(view);
        if(view == 'card'){
          this.info = 'info';
          this.primary = 'primary';
        }else{
          this.primary = 'info';
          this.info = 'primary';
        }
    },
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, this.limit);
    },

  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
    VTable: require('./../../../../components/table/table.vue'),
  },

  mixins: [
    SearchMixin,
  ],

  mounted() {
    this.setInnerSidebar([
      {
        title: this.$t('static.supplier.filters.title'),
        options: [
          {
            title: this.$t('static.supplier.filters.today'),
            route: {
              name: 'supplier.index',
              query: {
                filter: 'today',
              },
            },
          },
          {
            title: this.$t('static.supplier.filters.all'),
            route: {
              name: 'supplier.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.supplier.create.title')}`,
          route: {
            name: 'supplier.create',
          },
        },
      },
    ]);
    
    accountService.rememberPerPage('get', {from: 'supplier'})
    .then((data) => {
      this.limit = data.size;
      this.all(1, this.limit);
    }).catch((error) => {
      console.log(error);
    });

    console.log(this.view);
    if(this.view == 'card'){
          this.info = 'info';
          this.primary = 'primary';
    }else{
          this.primary = 'info';
          this.info = 'primary';
    }
  },

  destroyed() {
    this.unsetInnerSidebar();
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    changeView: function(view){
      if(this.info != view){
        this.primary = this.info;
       this.info = view;
       if(this.info == 'info'){
          store.dispatch('setView','card');
        }else{
          store.dispatch('setView','list');
        }
      }
    },

    perPage(size){
      accountService.rememberPerPage('post', {from: 'supplier', perPage: size })
      .then((data) => {
        this.limit = data.size;
      }).catch((error) => {
        console.log(error);
      });
    },

    /**
     * Fetches paginated supplier.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all : debounce( function(page, limit) {
        this.loading = true;
        supplierService.items({
          page,
          limit,
          search: this.getSearch(this.limit),
          filter: this.$route.query.filter,
        }).then(() => {
          this.loading = false;
        }).catch(() => {
          this.loadProductsing = false;
        });
    },800),

    /**
     * Go to edit view for supplier.
     *
     * @param  {Object} supplier The supplier object.
     */
    editSupplier(supplier) {
      const name = 'supplier.edit';
      this.$router.push({
        name,
        params: { id: supplier.id },
      });
    },

    /**
     * Go to edit view for supplier new tab.
     *
     * @param  {Object} supplier The supplier object.
     */
    editSupplierNewTab(supplier) {
      const name = 'supplier.edit';
      const route = this.$router.resolve({
        name,
        params: { id: supplier.id },
      });
      window.open(route.href, '_blank');
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/supplier/index/index.js